export const config = {
  storage: {
    refreshToken: 'refreshToken',
    token: 'token',
    loginTime: 'loginTime',
  },
  emitter: {
    tokenIncorrect: 'tokenIncorrect',
  },
};